import React from 'react'
import SEO from '~/components/seo'
import { Paragon } from '~/components/Typography'
import { mediaqueries } from '../utils/mediaqueries'
import { AttentionBanner } from '~/components/AttentionBanner'
import styled from 'styled-components'

import Cart from '~/components/Cart'

const Content = styled.section`
  width: 100%;
  margin: 0 auto;

  ${({ theme: { toRem } }) => `
      max-width: ${toRem(1460)};
      padding: ${toRem(20)} ${toRem(8)}};
  `}

  @media ${mediaqueries.md} {
    ${({ theme: { toRem } }) => `
      padding: ${toRem(50)} ${toRem(30)} 40px;
      `}
  }
`

const Heading = styled.div`
  text-align: center;

  ${({ theme: { toRem } }) => `
      padding-bottom: ${toRem(20)};
  `}
`

const Wrapper = styled.div`
  flex: 0 0 100%;
  flex-wrap: wrap;
`

const CartPage = () => (
  <Wrapper>
    <SEO title="Indkøbskurv" />
    <Content>
      <Heading>
        <Paragon>Indkøbskurv</Paragon>
      </Heading>
      <AttentionBanner secondary>
        <span>🛍️ Rabatkoder kan anvendes ved kassen</span>
      </AttentionBanner>
      <Cart />
    </Content>
  </Wrapper>
)

export default CartPage
